import { fromJS } from 'immutable';
import { actions } from '../actions/sku';

const initialState = fromJS({
  imagePreview: {
    url: '',
    errorMessage: '',
    hasError: false,
    showLoading: false
  }
});

export default (state = initialState, action) => {
  const { type, payload } = action;
  if (type === actions.updateImagePreviewComponent) {
    return state.set('imagePreview', state.get('imagePreview').merge(payload));
  }
  if (type === actions.resetImagePreview) {
    return state.set('imagePreview', initialState.get('imagePreview'));
  }
  return state;
};
